import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import client from 'api'
import { AppThunk } from 'store'

const initialState = {
    // loading: true,
    // hasError: false,

    fetchingStatus: 'idle',
    fetchingError: null as any,

    createStatus: 'idle',
    createError: null as any,

    updateStatus: 'idle',
    updateError: null as any,

    issues: [] as any[],
    allIds: [],
    totalIssues: 0,
    issueTypes: [],
    issuePriorities: [],
    issueStatuses: [],
}

export const loadIssues = createAsyncThunk('issues/loadIssues', async () => {
    const res = await client.get('/api/ixweb/nurismeldung/')
    return res.data

    // const mock = {
    //     "HDR_ID": 24349, "HDR_H1_USERID": 331, "HDR_H1_TIMESTAMP": "2018-06-29T11:17:58", "HDR_H2_USERID": 85, "HDR_H2_TIMESTAMP": "2018-06-29T12:45:34", "ISSUENUMBER": "2018/00001", "SUBJECT": "Wasserschaden", "ISSUETYPEID": 74, "ISSUETYPENAME": "Technische Störung (TS)", "ISSUEPRIORITYID": 3,
    //     "ISSUEPRIORITY": "Normal", "ISSUESTATUSID": 5, "ISSUESTATUSNAME": "Auftrag erteilt", "ISSUESTATUSDATE": "2018-06-29T12:19:51", "ISSUEREPORTINGDATE": "2018-06-29T11:17:58", "ISSUESOLVEFROMDATE": "2018-06-29T11:17:58", "ISSUESOLVETILDATE": "2018-07-02T11:17:58", "OBJNR": 70, "RENTUNITID": null, "RENTUNITOBJNR": null,
    //     "RENTUNITNUMBER": null, "RENTUNITNAME": null, "RESPONSIBLEUSERID": 331, "RESPONSIBLEUSERNAME": "ixhaus", "RESPONSIBLEUSERFIRSTNAME": "iX", "RESPONSIBLEUSERLASTNAME": "Haus", "RESPONSIBLEUSEREMAIL": "a@b.c", "RESPONSIBLEUSERTELEFON": "01234 12345678"
    // }

    // let data: any[] = []
    // for(let i = 0; i< Math.floor(25 * Math.random()) + 25; i++) {
    //     data.push({...mock, HDR_ID: i, ISSUENUMBER: `2020/0000${i}`})
    // }

    // return data
})


export const createIssue = createAsyncThunk('issues/createIssue', async (data: any)  => {
    const res = await client.post('/api/ixweb/nurismeldung/', data)
    return res.data
})

export const updateIssue = createAsyncThunk('issues/updateIssue', async (data: any) => {
    await client.put(`/api/ixweb/nurismeldung/${data.HDR_ID}/`, data)
    return data
})

const fncSetIssues = function(state: any, issues: any){
    state.issues = issues
    state.allIds = state.issues.map((issue: any) => issue.HDR_ID)
    state.totalIssues = state.issues.length
}

const fncAddIssue = function(state: any, issue: any){
    state.issues = [...state.issues, issue]
    state.allIds = state.issues.map((issue: any) => issue.HDR_ID)
    state.totalIssues = state.issues.length
}

const fncUpdateIssue = function(state: any, issue: any){
    var idx = state.issues.findIndex((_issue: any) => _issue.HDR_ID === issue.HDR_ID)
    if (idx >= 0)
    {
        state.issues[idx] = issue
    }
    else
    {
        fncAddIssue(state, issue)
    }
}

const issuesSlice = createSlice({
    name: 'issues',
    initialState,
    reducers: {
        setIssues: (state, action) => {
            fncSetIssues(state, action.payload)
        },
        removeIssue: (state, action) => {
            state.issues = state.issues.filter((issue: any) => issue.HDR_ID !== action.payload)
        },
        removeIssues: (state, action) => {
            state.issues = state.issues.filter((issue: any) => action.payload.indexOf(issue.HDR_ID) === -1)
        },
        addIssue: (state, action) => {
            fncAddIssue(state, action.payload)
        },
        setIssueTypes: (state, action) => {
            state.issueTypes = action.payload
        },
        setIssueStatuses: (state, action) => {
            state.issueStatuses = action.payload
        },
        setIssuePriorities: (state, action) => {
            state.issuePriorities = action.payload
        },
        resetCreateStatus: (state) => {
            state.createStatus = 'idle'
            state.createError = null
        },
        resetUpdateStatus: (state) => {
            state.updateStatus = 'idle'
            state.updateError = null
        },
    },
    extraReducers: builder => {
        builder.addCase(loadIssues.pending, (state) => {
            state.fetchingStatus = 'pending'
            state.fetchingError = null
        })
        builder.addCase(loadIssues.fulfilled, (state, action) => {
            state.fetchingStatus = 'idle'
            fncSetIssues(state, action.payload)
        })
        builder.addCase(loadIssues.rejected, (state, action) => {
            state.fetchingStatus = 'error'
            state.fetchingError = action.error.message
        })

        builder.addCase(createIssue.pending, (state) => {
            state.createStatus = 'pending'
            state.createError = null
        })
        builder.addCase(createIssue.fulfilled, (state, action) => {
            state.createStatus = 'fulfilled'
            fncAddIssue(state, action.payload)
        })
        builder.addCase(createIssue.rejected, (state, action) => {
            state.createStatus = 'error'
            state.createError = action.error.message
        })

        builder.addCase(updateIssue.pending, (state) => {
            state.updateStatus = 'pending'
            state.updateError = null
        })
        builder.addCase(updateIssue.fulfilled, (state, action) => {
            state.updateStatus = 'fulfilled'
            fncUpdateIssue(state, action.payload)
        })
        builder.addCase(updateIssue.rejected, (state, action) => {
            state.updateStatus = 'error'
            state.updateError = action.error.message
        })
    }
})

export const deleteIssue = (issueId: number): AppThunk => async (dispatch) => {
    try {
        await client.delete(`/api/ixweb/nurismeldung/${issueId}/`)

        dispatch(removeIssue(issueId))
    } catch(e) {
        return
    }
}

export const deleteIssues = (issueIds: number[]): AppThunk => (dispatch) => {
    issueIds.forEach((issueId) => dispatch(deleteIssue(issueId)))
}

export const loadIssueTypes = (): AppThunk => async (dispatch) => {
    try {
        const res = await client.get('/api/ixweb/nurismeldungsart/')
        dispatch(setIssueTypes(res.data))
    } catch(e) {
        return
    }
}

export const loadIssueStatuses = (): AppThunk => async (dispatch) => {
    try {
        const res = await client.get('/api/ixweb/nurismeldstatart/')
        dispatch(setIssueStatuses(res.data))
    } catch(e) {
        return
    }
}

export const loadIssuePriorities = (): AppThunk => async (dispatch) => {
    try {
        const res = await client.get('/api/ixweb/nurismeldprio/')
        dispatch(setIssuePriorities(res.data))
    } catch(e) {
        return
    }
}

export const { setIssues, removeIssue, removeIssues, addIssue, setIssueTypes, setIssueStatuses, setIssuePriorities, resetCreateStatus, resetUpdateStatus } = issuesSlice.actions
export default issuesSlice.reducer
